import {BaseEntity} from './base-entity';
import {SharedDocumentStatusType} from './shared-document';
import {DocumentDetail} from './history-shared-document';

export class DocumentsPackageHistoryRecord extends  BaseEntity {
    SharedDocumentsPackageGuid: string;
    lastUpdatedTimeStamp: number;
    packageHistoryItemRead: boolean;
    documentDetails: DocumentDetail[] = [];
    constructor (documentsPackageHistoryRecord?: DocumentsPackageHistoryRecord){
        super(documentsPackageHistoryRecord);
        if (documentsPackageHistoryRecord && documentsPackageHistoryRecord.documentDetails) {
            this.documentDetails = [];
            documentsPackageHistoryRecord.documentDetails.forEach((document) => {
                this.documentDetails.push(document);
            });
        }
    }

    getHistorySharedDocumentByName(documentName: string): DocumentDetail {
        return this.documentDetails.find( item => item.documentName === documentName);
    }
}
